<div *ngIf="graphStackCurrentIndex >= 0">  
  <h2>{{ graphStack[graphStackCurrentIndex].title }}</h2>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <button [disabled]="graphStackCurrentIndex <= 0" mat-button fxLayout="row" fxLayoutAlign="space-between center" (click)="onBackClick()">
      <mat-icon>arrow_back</mat-icon> Back
    </button>
    <button mat-flat-button color="primary" fxLayout="row" fxLayoutAlign="space-between center" (click)="onDownloadDataClick()">
      <mat-icon>download</mat-icon> Download Data
    </button>
  </div>
  <div class="m-b-5" style="height: 1em;">
    <span *ngIf="graphStack[graphStackCurrentIndex].alternativeViewFunc" class="m-l-20">Alternative View:
      <a (click)="graphStack[graphStackCurrentIndex].alternativeViewFunc()" style="cursor: pointer;">{{ graphStack[graphStackCurrentIndex].alternativeViewTitle }}</a>
    </span>
  </div>
  <div style="display: block;" class="chart-container">
    <canvas baseChart
            [datasets]="graphStack[graphStackCurrentIndex].barChartData"
            [labels]="graphStack[graphStackCurrentIndex].barChartLabels"
            [options]="barChartOptions"
            [legend]="true"
            [chartType]="'bar'"
            (chartClick)="onGraphClicked($event)">
    </canvas>
  </div>
</div>